<template>
  <div class="input-block d-flex flex-column ml-4 mr-8">
    <p class="mb-0 grey-font text-body-2 text-center">
      {{ title }}
    </p>

    <v-form @submit.prevent>
      <v-text-field outlined type="number" class="text-body-2" step="0.01" color="rgba(0, 0, 0, 0.6)"
        v-model.number="inputValue" :min="min" :max="max" :rules="rules" :suffix="suffix" @blur="handleBlur"
        data-cy="input">
        <template v-slot:append>
          <v-fade-transition leave-absolute>
            <div class="d-flex flex-column mb-4">
              <v-icon :disabled="isIncreaseDisabled" @click="handleIncrease" data-cy="increase">
                mdi-plus-box
              </v-icon>

              <v-icon :disabled="isDecreaseDisabled" @click="handleDecrease" data-cy="decrease">
                mdi-minus-box
              </v-icon>
            </div>
          </v-fade-transition>
        </template>
      </v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'AdditionalServiceInput',
  props: {
    id: { type: String },
    title: { type: String },
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 0 },
    rules: { type: Array },
    suffix: { type: String, default: '€' },
    changeRate: { type: Number, default: 0.1 },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    }
  },
  computed: {
    isIncreaseDisabled() {
      return this.inputValue >= this.max
    },
    isDecreaseDisabled() {
      return this.inputValue <= this.min
    },
  },
  methods: {
    handleBlur() {
      if (this.inputValue !== 0 && this.inputValue < this.min) {
        this.inputValue = this.min;
      }

      if (this.inputValue > this.max) {
        this.inputValue = this.max;
      }

      this.$emit('onInputChange', this.id, this.inputValue)
    },
    handleIncrease() {
      const newValue = parseFloat((this.inputValue + this.changeRate).toFixed(2))

      this.inputValue = Math.min(newValue, this.max)
      this.$emit('onInputChange', this.id, this.inputValue)
    },
    handleDecrease() {
      const newValue = parseFloat((this.inputValue - this.changeRate).toFixed(2))

      if (newValue < this.min && newValue !== 0) {
        this.inputValue = this.min;
      } else {
        this.inputValue = Math.max(newValue, 0);
      }

      this.$emit('onInputChange', this.id, this.inputValue)
    },
  },
}
</script>

<style scoped lang="scss">
.input-block {
  width: rem(120);
}
</style>
